/**
 @author xiaoye
 @date 2020/4/13 12:41 下午
 */
import {Guuid} from '@/assets/js/basis'
import modules from '../../charts/script/modules'

//生成图表
export default (dropVal, data) => {
    let module = modules[dropVal.type];
    let op = module.option;
    let uuid = Guuid();
    //多维分析配置参数 【所需的配置项】
    let viewDpConfig = {};
    //别名
    let aliasName = dropVal.name || '图表别名';
    if (data.chartType === 1) {
        try {
            viewDpConfig = JSON.parse(dropVal.viewChart.requestJson);
            aliasName = dropVal.viewChart.dataViewName || dropVal.name || '图表别名';
        } catch (e) {
            viewDpConfig = {};
        }
    }
    return {
        //uuid *
        id: 'dp_' + module.class + '_' + uuid,
        //拖动框的类型 0 基本图表 1 多维分析 2 元素
        dragType: data.chartType,
        //大类型
        type: module.type,
        //类别
        class: module.class,
        //当前组件 小类型
        name: dropVal.name,
        //别名
        aliasName: aliasName,
        //自定义组件
        component: module.component,
        componentShow: module.component ? true : false,
        //默认展示
        trans: {
            //X轴位置
            x: data.x || 0,
            //y轴位置
            y: data.y || 0,
            //层级
            z: data.z,
            //是否禁止拖拽
            isNoDrag: false,
            //宽
            width: op.dp_wight || 300,
            //高
            height: op.dp_height || 200,
            //最小宽度
            minWidth: op.dp_min_wight || 50,
            //最小高度
            minHeight: op.dp_min_height || 50,
        },
        //背景
        backColor: data.backColor,
        //保存的配置参数
        saveOption: viewDpConfig,
        //多维分析配置参数
        viewDP: {
            viewId: dropVal.viewChart.id || '',
            returnData: {},
        },
        //是否默认选中
        active: true,
        //是否加载
        _isLoad: false,
        //是否锁定图层
        _isLock: false,
        //是否显示预览图
        _isPImg: true,
        //是否渲染失败
        _isError: false,
        //是否渲染失败
        _isNoData: false,
    }
}